import React, { useRef, useState } from 'react'
import Empty from '../../components/Display/Empty'
import EmptyBox from '../../assets/animations/empty_box.json'
import Button from '../../components/General/Button'
import { FiTrash2 } from 'react-icons/fi'
import FieldArrayAutocomplete from '../../components/Inputs/FieldArrayAutocomplete'
import ModalConfirm from '../../components/Display/ModalConfirm'
import InputCheck from '../../components/Inputs/InputCheck'

const UnloadForm: React.FC<UnloadFormProps> = ({
  onClose,
  onUnload,
  warehouseId,
}) => {
  const [mockItemsLoaded, setMockItemsLoaded] = useState<ItemsLoaded[]>([])

  const [modalConfirm, setModalConfirm] = useState<boolean>(false)

  const [newRowState] = useState<any>(null)

  const refDivScroll = useRef<HTMLDivElement | null>(null)

  const [accounting, setAccounting] = useState<boolean>(true)


  const deleteItemFromLoad = (id) => {
    setMockItemsLoaded((state) => state.filter((item) => item.idItem !== id))
  }

  // const _valueAvailableToSet = () => {

  // }

  const addItemToLoad = ({ value, amount }) => {
    
    refDivScroll.current?.scrollTo(0, 0)
    setMockItemsLoaded((state) => [...state, {idItem: value.id, name: value.name, amount}])

    // setNewRowState(newRow)

    // if (+amount > +value.quantity && value.quantity >= 0) {
    //   setModalConfirm(true)
    // } else {
    //   setMockItemsLoaded((state) => [...state, newRow])
    // }
  }

  const loadInventory = () => {
    if (mockItemsLoaded.length > 0) onUnload(mockItemsLoaded, accounting)
  }

  return (
    <div>
      <h1 className="mb-3">Descarga de Artículos</h1>
      <div className="max-h-80 overflow-y-auto" ref={refDivScroll}>
        {mockItemsLoaded.length > 0 &&
          mockItemsLoaded.map((item) => (
            <div
              className="bg-gray-100 dark:bg-gray-800 rounded-lg my-4 p-2 flex justify-between items-center"
              key={item?.idItem}
            >
              <div className="truncate">
                <h1 className="text-sm ml-3">{item?.name}</h1>
                <h1 className="text-sm ml-3">
                  {item?.amount}
                  {/* {formatAmount(item?.amount, item?.unit)} */}
                </h1>
              </div>

              <Button
                classes="border-none"
                onClick={() => deleteItemFromLoad(item?.idItem)}
              >
                <FiTrash2 size={20} color="red" />
              </Button>
            </div>
          ))}
      </div>

      {mockItemsLoaded.length === 0 && (
        <Empty
          animationProps={{
            height: 200,
            width: 200,
            animation: EmptyBox,
          }}
          lottieProps={{ style: { position: 'relative', zIndex: 1 } }}
        >
          <p className="font-semibold max-w-xs text-center relative-top-5 z-10 text-sm text-coolGray-500">
            Agrega artículos para cargarlos a su existencia
          </p>
        </Empty>
      )}
      <div className="my-3">
        <InputCheck
          label="Generar asiento contable"
          value={accounting}
          helperFunction={(value) => setAccounting(value)}
        />
      </div>
      <div className="grid grid-cols-12 gap-x-6 gap-y-2">
        <FieldArrayAutocomplete
          url="inventory/item/simple-search"
          bodyGet="items"
          queryParam="param"
          queryParamsId={warehouseId}
          valuesToCompare={mockItemsLoaded}
          onChangeValue={addItemToLoad}
          useCase="UNLOAD"
        />
      </div>
      <div className="flex space-x-2 mt-3 px-1 block">
        {onClose && (
          <Button
            type="outline"
            classes="w-1/2 mr-4"
            onClick={() => onClose()}
            htmlType="button"
          >
            Cancelar
          </Button>
        )}
        <Button
          type="primary"
          classes={`w-1/2 mr-4 ${
            mockItemsLoaded.length === 0 && 'opacity-20 cursor-default'
          }`}
          htmlType="button"
          onClick={loadInventory}
        >
          Descargar Inventario
        </Button>
      </div>
      <ModalConfirm
        onCancel={() => setModalConfirm(false)}
        onConfirm={() => {
          setMockItemsLoaded((state) => [...state, newRowState])
          setModalConfirm(false)
          refDivScroll.current?.scrollTo(0, 0)
        }}
        displayConfirmModal={modalConfirm}
        title="¿Esta seguro que desea descargar esta cantidad? El retiro de la misma causará una existencia negativa."
      />
    </div>
  )
}

interface UnloadFormProps {
  onClose: Function
  onUnload: Function
  warehouseId: string | undefined
}

interface ItemsLoaded {
  idItem: string
  name: string
  // unit: IUnit
  amount: number
}

export default UnloadForm
